import { Modal, Button } from "react-bootstrap";
import AddCustomFields from "../../Initiate/NewClientPortal/AddCustomFields";
import { useContext, useEffect, useState } from "react";
import StateContext from "../../../context/State";
import PortalService from '../../../services/portal.service';
import { CustomField } from "../../../types";
import { RPWDataReader, getDataReader } from "../../../../../livedataFuncs";
import { useAppSelector } from "../../../../../redux/hooks";
import { lddStateObject } from "../../../../../redux/reducer";


export type AddCustomFieldModalProps = {
    onHideModal: () => void;
    getCustomFieldsData: () => void;
    showModal: boolean;
}

const AddCustomFieldModal = (props: AddCustomFieldModalProps) => {

    const { state } = useContext(StateContext);
    const portalService = new PortalService(state);

    const [customFields, setCustomFields] = useState<CustomField[]>([]);
    const [customFieldSetNames, setCustomFieldSetNames] = useState<string[]>([])

    const [addRow, setAddRow] = useState<boolean>(false);
    const [customFieldSubmitted, setCustomFieldSubmitted] = useState<boolean>(false);
    const [clientInfo, setClientInfo] = useState([]);
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(livedataRootContainer.dataRoot);
    
    useEffect(() => { getClientInfo(); }, [])

    const getClientInfo = async () => {
        const province = portalService.getProvince();
        const names = DataReaderObj.getUserNames(province);
        setClientInfo(names);
    }

    const setCustomFieldsData = async (portalId) => {
    
        try {
            // Filter and transform fields before submitting
            const processedFields = customFields.map((field) => {
                if (field.perClient) {
                    // Create a JSON object for client-specific values and stringify it
                    const clientValues = clientInfo.reduce((obj, clientName) => {
                        obj[clientName] = ""; // Start with empty strings for each client
                        return obj;
                    }, {});
                    return {
                        ...field,
                        identifier: field.identifier ? field.identifier : JSON.stringify(clientValues)
                    };
                } else {
                    if (field.identifier !== null) {
                        return {
                            ...field,
                            identifier: field.identifier // Reassign the existing value
                        };
                    }
                }
                return { ...field }; // Return the field unchanged if not perClient and no identifier
            });
    
            const res = await portalService.setClientPortalCustomFields(portalId, processedFields, 'afterInit');
            if (res === "Created") {
                setCustomFieldSubmitted(false);
                props.onHideModal();
                props.getCustomFieldsData();
                window.location.reload();
            }
            alert('Submitted Custom Fields!');
        } catch (e) {
            console.log('Unable to set Custom Fields: ', e);
        }
    }

    return (
        <>
            <Modal
                show={props.showModal}
                onHide={props.onHideModal}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                size="xl"
                className="modal-list"
            >
                <Modal.Header closeButton>
                    <h2 id="contained-modal-title-vcenter">{customFields.length === 0 ? 'Add' : 'Edit'} Custom Fields</h2>
                </Modal.Header>

                <Modal.Body>
                    <AddCustomFields
                        setCustomFields={setCustomFields}
                        addRow={addRow}
                        setAddRow={setAddRow}
                        setCustomFieldSetNames={setCustomFieldSetNames}
                        customFieldSetNames={customFieldSetNames}
                        afterInit={true}
                    />
                </Modal.Body>

                <Modal.Footer>
                    {/* <Button variant='outline-primary' onClick={() => { setAddRow(!addRow) }}>
                        Add Row
                    </Button> */}
                    <Button
                        disabled={customFieldSubmitted}
                        onClick={() => {
                            setCustomFieldsData(state.portalId);
                        }}
                    >
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AddCustomFieldModal;
